import { Component, OnInit } from '@angular/core';
import {AdminService} from "../../../services/admin/admin.service";
import { Message } from 'primeng/components/common/api';
import { IFile } from '../../../models/outModels/File';
import { saveAs } from "file-saver";
import * as moment from 'moment';

@Component({
  selector: 'app-weekly-dashboard',
  templateUrl: './weekly-dashboard.component.html',
  styleUrls: ['./weekly-dashboard.component.css']
})
export class WeeklyDashboardComponent implements OnInit {
	loading: boolean;
	data;
	selectedFile:IFile;
	downloading = false;
	error: Message[];
	subscriptionChannelPieData: any;
	chartOptions: any;
	dateRange: Date[];
	maxDate = moment().endOf("day").toDate();
	constructor(
		private adminService: AdminService) {
		this.chartOptions =
		{
			maintainAspectRatio: false
		};
		var start = moment().add(-1, "month").startOf("month");
		this.dateRange = new Array(2);
		this.dateRange[0] = start.toDate();
		this.dateRange[1] = start.add(1,"month").add(-1,"second").toDate();
	}

	ngOnInit() {
		this.filter();
	}
	  	
	filter() {
		if (this.dateRange == undefined || this.dateRange.length < 2 || this.dateRange.indexOf(null) != -1) {
			return;
		}

		this.loading = true;
		//this.adminService.getDashWeekModel(this.dateRange[0].toISOString(),this.dateRange[1].toISOString()).then(
		//	result => {
		//		this.data = result;
		//		this.loading = false;
		//		this.subscriptionChannelPieData= {
		//			labels: ['Printed Cards','Online'],
		//			datasets: [
		//				{
		//					data: [this.data.physicalSubscribers,this.data.onlineSubscribers],
		//					backgroundColor: [
		//						"#FF6384",
		//						"#36A2EB"
		//					],
		//					hoverBackgroundColor: [
		//						"#FF6384",
		//						"#36A2EB"
		//					]
		//				}]    
		//		};
		//	},
		//	error => {
		//		console.log(error);
		//		this.loading = false;
		//		this.error = [];
		//		this.error.push({ severity: 'error', summary: 'Error', detail: error });
		//	}
		//);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/admin/weekly-dashboard/weekly-dashboard.component.ts